import { render, staticRenderFns } from "./VxRadio.vue?vue&type=template&id=52757732"
import script from "./VxRadio.vue?vue&type=script&lang=js"
export * from "./VxRadio.vue?vue&type=script&lang=js"
import style0 from "./VxRadio.vue?vue&type=style&index=0&id=52757732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports